import * as React from "react";
import { TableFooter, TableRow, TableCell } from "@material-ui/core";

import { IPoliciesTableProps } from "../PoliciesTable";
import { Pagination } from "../../../components/Pagination";

export const PolicyTableFooter: React.FunctionComponent<
  IPoliciesTableProps
> = ({ onChangePage, pagination, totalItems }) => (
  <TableFooter>
    {onChangePage && (
      <TableRow>
        {pagination && (
          <TableCell>
            <Pagination
              totalItems={totalItems || 0}
              pagination={pagination}
              onChangePage={onChangePage}
            />
          </TableCell>
        )}
      </TableRow>
    )}
  </TableFooter>
);
